export const GET_ESG_COVERAGE = 'GET_ESG_COVERAGE';
export const GET_ESG_COVERAGE_SUCCESS = 'GET_ESG_COVERAGE_SUCCESS';
export const GET_ESG_COVERAGE_ERROR = 'GET_ESG_COVERAGE_ERROR';

export const getESGCoverageAction = {
  type: GET_ESG_COVERAGE,
};
